import { Box, Paper, Skeleton, Typography } from "@mui/material";

const TONES = {
  neutral: { color: "primary.main", bgcolor: "rgba(var(--primary-rgb), 0.08)" },
  warning: { color: "#b26a00", bgcolor: "rgba(255, 152, 0, 0.14)" },
  error: { color: "#c62828", bgcolor: "#fdecea" },
};

// A row of numbers at the top of a dashboard page.
// `cards`: [{ label, value, note, Icon, tone }]; `value` undefined while loading.
export default function SummaryCards({ cards }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          lg: `repeat(${cards.length}, minmax(0, 1fr))`,
        },
        gap: { xs: 1.5, sm: 2 },
        mb: 3,
      }}
    >
      {cards.map(({ label, value, note, Icon, tone = "neutral" }) => (
        <Paper
          key={label}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            p: { xs: 1.5, sm: 2 },
            borderRadius: "8px",
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: "10px",
              flexShrink: 0,
              ...TONES[tone],
            }}
          >
            <Icon sx={{ fontSize: 22 }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: 13, color: "text.secondary" }}>
              {label}
            </Typography>
            {value === undefined ? (
              <Skeleton width={60} height={32} />
            ) : (
              <Typography
                noWrap
                sx={{
                  fontSize: { xs: 18, sm: 22 },
                  fontWeight: 700,
                  color: tone === "neutral" ? "#111827" : TONES[tone].color,
                  lineHeight: 1.4,
                }}
              >
                {value}
                {note && (
                  <Box
                    component="span"
                    sx={{
                      // Phones: under the number.
                      display: { xs: "block", sm: "inline" },
                      ml: { xs: 0, sm: 0.5 },
                      lineHeight: 1.2,
                      fontSize: 13,
                      fontWeight: 500,
                      color: "text.secondary",
                    }}
                  >
                    {note}
                  </Box>
                )}
              </Typography>
            )}
          </Box>
        </Paper>
      ))}
    </Box>
  );
}

// Total area of the rows, rounded so it doesn't show long decimals.
export const sumArea = (items) =>
  Math.round(
    items.reduce((sum, item) => sum + (Number(item.area) || 0), 0) * 100,
  ) / 100;
